import { api } from "../../api";

// Account-level tip opt-out, shared by TipBar and the playlist coach mark.
// Dismissals live in user.preferences.dismissedTips (backend: POST
// /user/tips/:tipId/dismiss) and in the cached user in context/localStorage.

export function isTipDismissed(user, tipId) {
  return !!user?.preferences?.dismissedTips?.includes?.(tipId);
}

export function dismissTip(tipId, user, setUser) {
  if (!tipId) return;
  // Optimistic: hide immediately; worst case (request fails) the tip shows
  // once more on a future open.
  api.post(`/user/tips/${encodeURIComponent(tipId)}/dismiss`).catch(() => {});
  if (!user || !setUser) return;
  const prevTips = user.preferences?.dismissedTips || [];
  const updated = {
    ...user,
    preferences: {
      ...user.preferences,
      dismissedTips: prevTips.includes(tipId) ? prevTips : [...prevTips, tipId],
    },
  };
  setUser(updated);
  try {
    // Same key authService writes, so the opt-out survives a reload.
    localStorage.setItem("user", JSON.stringify(updated));
  } catch {
    /* private mode etc. — the context update still applies */
  }
}
